module.exports = __webpack_public_path__ + "static/media/axlir_small.eadcfefb.png";